<template>
  <v-container pa-0>
    <v-layout>
      <v-container class="justify">
        <v-flex xs12 mb-2>
          <h2 class="font-weight-light secondary--text" v-text="page_title"></h2>
          <v-spacer></v-spacer>
          <span
            class="mt-2 secondary--text"
          >{{ months[getDate.getMonth()] }} {{ getDate.getDate() }}, {{getDate.getFullYear()}}</span>
        </v-flex>
        <template>
          <v-card>
            <v-card-title>
              <v-layout row wrap>
                <div>
                  <h3 class="font-weight-regular">ANALYTICS</h3>
                </div>
                <v-spacer></v-spacer>
                <div>
                  <v-btn
                    class="ma-0"
                    :class="{'primary--text':show_time.week}"
                    small
                    @click="show_week"
                  >Week</v-btn>
                  <v-btn
                    class="ma-0"
                    :class="{'primary--text':show_time.month}"
                    small
                    @click="show_month"
                  >Month</v-btn>
                </div>
              </v-layout>
            </v-card-title>
            <v-card-text>
              <div>
                <v-layout>
                  <v-flex xs10 sm4 pa-2>
                    <v-layout column>
                      <label class="pb-1">Sort By</label>
                      <v-select solo v-model="category_select" :items="category"></v-select>
                    </v-layout>
                  </v-flex>

                  <!-- Bank  -->
                  <v-flex v-if="category_select=='Bank'" xs10 sm4 pa-2>
                    <v-layout column>
                      <label class="pb-1">Select Bank</label>
                      <v-select
                        solo
                        v-model="bank_select"
                        :items="banks"
                        item-text="name"
                        item-value="id"
                        @change="suffix"
                      ></v-select>
                    </v-layout>
                  </v-flex>

                  <!-- State -->
                  <v-flex v-if="category_select=='State'" xs10 sm4 pa-2>
                    <v-layout column>
                      <label class="pb-1">Select state</label>
                      <v-select
                        solo
                        v-model="state_select"
                        :items="states"
                        item-text="name"
                        item-value="value"
                        @change="suffix"
                      ></v-select>
                    </v-layout>
                  </v-flex>

                  <!-- Route Marshal -->
                  <v-flex v-if="category_select=='Route Marshal'" xs10 sm4 pa-2>
                    <v-layout column>
                      <label class="pb-1">Route Marshal</label>
                      <v-autocomplete
                        solo
                        v-model="marshal_select"
                        :items="marshals"
                        item-text="username"
                        placeholder="Marshal Username"
                        item-value="username"
                        @change="suffix"
                      ></v-autocomplete>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
              <div>
                <v-flex mb-4 justify-end>
                  <v-btn
                    color="accent darken-3"
                    slot="activator"
                    @click="show_snackbar('File Downloaded successfully!','primary','/admin')"
                  >Download</v-btn>
                </v-flex>
              </div>
              <div class="mb-5">
                <v-layout row wrap>
                  <v-flex xs4>
                    <v-card color="secondary" class="full-width mr-2 py-4 px-1 text-xs-center" dark>
                      <v-layout row wrap>
                        <v-flex xs12 sm5 justify-center>
                          <img src="@/assets/merchants.svg" alt="merchants" width="60" height="60">
                        </v-flex>
                        <v-flex>
                          <div class="pl-2">
                            <h2 v-text="total_visits" class="py-2 text-sm-left"></h2>
                            <h5 class="font-weight-regular">Total Visitations</h5>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex xs4>
                    <v-card color="success" class="full-width mr-2 py-4 px-1 text-xs-center" dark>
                      <v-layout row wrap>
                        <v-flex xs12 sm5 justify-center>
                          <img src="@/assets/visit.svg" alt="marshal" width="60" height="60">
                        </v-flex>
                        <v-flex>
                          <div class="pl-2">
                            <h2 v-text="total_done" class="py-2 text-sm-left"></h2>
                            <h5 class="font-weight-regular">Visitations Done</h5>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                  <v-flex xs4>
                    <v-card color="info" class="full-width mr-2 py-4 px-1 text-xs-center" dark>
                      <v-layout row wrap>
                        <v-flex xs12 sm5 justify-center>
                          <img src="@/assets/percent.svg" alt="percent" width="60" height="60">
                        </v-flex>
                        <v-flex>
                          <div class="pl-2">
                            <h2 v-text="percent_done" class="py-2 text-sm-left"></h2>
                            <h5 class="font-weight-regular">Percentage(%)</h5>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-flex>
                </v-layout>
              </div>
              <div class="bar-chart">
                <bar-chart
                  class="bar-chart"
                  :chart-options="chart_options"
                  :chart-data="datacollection"
                ></bar-chart>
              </div>

              <div class="my-5">
                <v-layout row wrap>
                  <v-flex xs12 sm6 justify-center>
                    <v-progress-circular
                      :rotate="-90"
                      :size="300"
                      :width="45"
                      :value="percent_done"
                      color="success"
                    >{{ percent_done }}%</v-progress-circular>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-layout column justify-center>
                      <div>
                        <div class="box success mr-2"></div>
                        <h3 class="d-inline font-weight-regular">
                          Percent Completed
                          (
                          <span v-text="percent_done"></span>%)
                        </h3>
                      </div>
                      <div>
                        <div class="box grey mr-2"></div>
                        <h3 class="d-inline font-weight-regular">Total Percentage</h3>
                      </div>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </div>
            </v-card-text>
            <v-snackbar
              v-model="snackbar.show"
              bottom
              right
              :color="snackbar.color"
              :timeout="snackbar.timeout"
            >
              {{ snackbar.text }}
              <v-flex justify-end>
                <v-btn
                  flat
                  v-if="snackbar.url"
                  :to="snackbar.url"
                  @click="snackbar.show = false"
                >Go to</v-btn>
                <v-btn flat @click="snackbar.show = false">Close</v-btn>
              </v-flex>
            </v-snackbar>
          </v-card>
        </template>
      </v-container>
    </v-layout>
  </v-container>
</template>
<script>
import AnalyticsLayout from "../../../layouts/admin"
import utils from "@/common/utils"
import { mapState } from "vuex"
import BarChart from "@/components/chart.js"

export default {
  name: "Analytics",
  components: {
    BarChart
  },
  data() {
    return {
      show_time: {
        week: true,
        month: false
      },
      category: ["Overall", "Bank", "State", "Route Marshal"],
      category_select: "Overall",
      bank_select: "Access Bank",
      state_select: "Lagos",
      marshal_select: "Abosede",
      main_label: this.months,
      main_dataset_total: [
        300,
        400,
        300,
        400,
        350,
        500,
        300,
        400,
        300,
        400,
        350,
        500
      ],
      main_dataset_done: [
        250,
        280,
        150,
        300,
        250,
        460,
        50,
        400,
        230,
        330,
        310,
        300
      ],
      datacollection: null,
      chart_options: {
        responsive: true,
        maintainAspectRatio: false
      },
      snackbar: {
        show: false,
        timeout: 7000,
        text: "",
        color: "",
        url: ""
      },
      page_title: "Analytics",
      getDate: new Date(),
      months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    }
  },
  computed: {
    ...mapState({
      banks: state => state.common.banks,
      marshals: state => state.admin.marshals
    }),
    total_done() {
      var total = 0
      var array = this.main_dataset_done
      array.forEach(element => {
        total += element
      })
      return total
    },
    total_visits() {
      var total = 0
      var array = this.main_dataset_total
      array.forEach(element => {
        total += element
      })
      return total
    },
    percent_done() {
      return ((this.total_done / this.total_visits) * 100).toFixed(2)
    },
    states() {
      console.log(utils.STATE_CHOICES)
      return utils.STATE_CHOICES
    }
  },
  methods: {
    toroute(route) {
      this.$router.push(route)
    },
    show_snackbar(message, color, url) {
      utils.showSnackbar({message, url, color, timeout:10000})
    },
    suffix(value) {
      this.page_title = "Analytics - " + value
    },
    show_week() {
      this.show_time.week = true
      this.show_time.month = false
    },
    show_month() {
      this.show_time.month = true
      this.show_time.week = false
    },
    fillData() {
      this.datacollection = {
        labels: this.months,
        datasets: [
          {
            label: "Total Visitations",
            backgroundColor: "#424242",
            data: this.main_dataset_total
          },
          {
            label: "Visitations Done",
            backgroundColor: "#4CAF50",
            data: this.main_dataset_done
          }
        ]
      }
    }
  },
  created() {
    this.$emit("update:layout", AnalyticsLayout)
  },
  mounted() {
    this.fillData()
  }
}
</script>

<style>
.bar-chart,
canvas#bar-chart {
  height: 550px !important;
  width: 100%;
  max-width: 1200px
}
.full-width {
  width: 100%
}
</style>


